module.exports = __webpack_public_path__ + "img/czech-republic.3ee4e8d3.svg";